import { appManager, AppState } from '../manager';
import { arrayToIndexedObject } from 'services/indexedObject';
import type {
  Preset,
  CreatePresetPayload,
  PresetTrainerAvailability,
} from './types';

export const createPreset = appManager.createApi<
  // CreatePresetPayload,
  { preset_name: string },
  Preset,
  AppState
>('CREATE_PRESET', {
  method: 'POST',
  path: '/presets/create_new_preset',
  startReducer(state, props) {
    state.presets.waiting = true;
  },
  successReducer(state, result) {
    state.presets.items[result.id] = result;
    state.presets.waiting = false;
  },
  failReducer(state, props) {
    state.presets.waiting = false;
  },
});

export const listPresets = appManager.createApi<unknown, Preset[], AppState>(
  'LIST_PRESETS',
  {
    method: 'GET',
    path: '/presets',
    startReducer(state, props) {
      state.presets.waiting = true;
    },
    successReducer(state, result) {
      state.presets.items = arrayToIndexedObject(result);
      state.presets.waiting = false;
    },
    failReducer(state, result) {
      state.presets.waiting = false;
    },
  }
);

export const fetchPresetTrainerAvailability = appManager.createApi<
  unknown,
  PresetTrainerAvailability[],
  AppState
>('FETCH_PRESET_TRAINER_AVAILABILITY', {
  method: 'GET',
  path: '/presets/trainer_availability',
  startReducer(state) {
    state.presets.availabilityWaiting = true;
  },
  successReducer(state, result) {
    state.presets.trainerAvailability = result.reduce(
      (availability, item) => ({
        ...availability,
        [item.preset_id]: item,
      }),
      {},
    );
    state.presets.availabilityWaiting = false;
  },
  failReducer(state) {
    state.presets.availabilityWaiting = false;
  },
});

export const makePresetAssetVisible = appManager.createApi<
  { preset_id: number; asset_id: number },
  PresetTrainerAvailability,
  AppState
>('MAKE_PRESET_ASSET_VISIBLE', {
  method: 'POST',
  path: '/presets/:preset_id/make_asset_visible',
  startReducer(state, payload) {
    state.presets.unhidingAssetId = payload.asset_id;
  },
  successReducer(state, result, payload) {
    state.presets.trainerAvailability[result.preset_id] = result;
    const asset = state.underlying_assets.items[payload.asset_id];
    if (asset) asset.visible = true;
    state.presets.unhidingAssetId = undefined;
  },
  failReducer(state) {
    state.presets.unhidingAssetId = undefined;
  },
});

export const updatePreset = appManager.createApi<Preset, Preset, AppState>(
  'UPDATE_PRESET',
  {
    method: 'POST',
    path: '/presets/:id/update_preset',
    successReducer(state, result) {
      state.presets.items[result.id] = result;
    },
  }
);

export const updatePresetName = appManager.createApi<
  { new_preset_name: string; preset_id: number },
  string,
  AppState
>('UPDATE_PRESET_NAME', {
  method: 'POST',
  path: '/presets/:preset_id/update_preset_name',
  successReducer(state, result, payload) {
    state.presets.items[payload.preset_id].name = result;
  },
});
